import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LOCALE, isAppLocale, readStoredPreferredLanguage, resolveAppLocale, type AppLocale } from './locales';
import { applyAmplifyVocabularies, syncAmplifyLanguage } from './amplifyLocale';
import { I18N_NAMESPACES, localeResources } from './resources';

const initialLocale = resolveAppLocale(readStoredPreferredLanguage());

void i18n.use(initReactI18next).init({
  resources: localeResources,
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: [...I18N_NAMESPACES],
  interpolation: {
    escapeValue: false
  },
  returnNull: false
});

applyAmplifyVocabularies();
syncAmplifyLanguage(initialLocale);

i18n.on('languageChanged', (lng: string) => {
  const locale: AppLocale = isAppLocale(lng) ? lng : DEFAULT_LOCALE;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
  syncAmplifyLanguage(locale);
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLocale;
}

export async function changeAppLanguage(locale: AppLocale): Promise<void> {
  await i18n.changeLanguage(locale);
}

export default i18n;
